//
//
//
//
//
//
//
//
//
//
//
//

// import TextareaBlock from 'components/combinedBlocks/Textarea.vue'
import InputFormBlock from 'components/combinedBlocks/InputForm.vue'
// import ButtonBlock from 'components/blocks/Button.vue'

export default {
  block: 'findSellerContact',
  props: ['data'],
  components: {
    // TextareaBlock,
    InputFormBlock,
    // ButtonBlock,
  },
  computed: {
  },
  methods: {
  },
  watch: {
    // 'data.visible': function(value) {
    //   this.visible = value;
    // },
  },
  // mounted() {
  // }
}



// WEBPACK FOOTER //
// ./components/combinedBlocks/FindSellerContact.vue